import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import Button from '../Button';

const useStyles = makeStyles({
  container: {
    padding: '1.3rem',
    // backgroundColor: '#EBF2F8',
    border: '0.05rem solid #cccccc',
  },
  button: {
    marginLeft: '-0.4rem',
    marginTop: '0.5rem',
  },
});

const TextBox = ({
  title,
  children,
  linktext,
  link,
  href,
  className,
  props,
}) => {
  const classes = useStyles();
  return (
    <div className={clsx(className)}>
      <div className={classes.container}>
        <Typography variant="h6">{title}</Typography>
        {children}
        {linktext && (
          <Button
            color="primary"
            variant="outlined"
            href={link ? `#${link}` : href}
            size="small"
            className={classes.button}
            {...props}
          >
            {linktext}
          </Button>
        )}
      </div>
    </div>
  );
};

TextBox.propTypes = {
  /** Title */
  title: PropTypes.any,
  /** Body of textbox */
  children: PropTypes.any,
  /** Button text */
  linktext: PropTypes.any,
  /** Internal link for button (prioritized over href) */
  link: PropTypes.any,
  /** External link for button */
  href: PropTypes.any,
  /** Custom styling for outer div */
  className: PropTypes.string,
  /** Props for Material UI Button component */
  props: PropTypes.any,
};

TextBox.defaultProps = {
  title: '',
  children: '',
  linktext: '',
  link: '',
  href: '',
  className: undefined,
  props: null,
};

export default TextBox;
